import React, { useEffect, useState, useRef } from 'react'

import M2niCascadedList from '../../components/selectionFolder/m2ni_cascaded_list/index'
import FileItemEdit from '../../components/selectionFolder/fileItem/fileItemEdit/index'
import style from './index.module.scss'
import GanttSchedule from '../../components/ganttSchedule/index'
import * as apis from '../../api/networkDisk'
import moment from 'moment'
import Paging from '../../components/pagination'

import useStore from '../../store/useStore'
// import originalSetItem from '../../modules/storage'
import { Tooltip, Modal, message, Table, DatePicker } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { getUserList } from '../../api/user'
import { createVoidZero } from 'typescript'
import { deepCopy } from '../../util'
const { confirm } = Modal;
const { RangePicker } = DatePicker;


interface Props {
    visible?: any,
    onClose?: () => void;
    onRefresh?: () => void;
    type?: any
}
interface DataType {
    key: React.Key;
    name: string;
}
let params: any = {}

const ExecutorList = (props: Props) => {
    const [taskData, setTaskData] = useState<any>([]);
    const { store, dispatch } = useStore();
    const [searchDate, setSearchDate] = useState<any>([]);

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(store.ganttExecutorRowKeys);
    const [selectedRows, setSelectedRows] = useState<any>(store.ganttExecutorRows);
    const [userList, setUserList] = useState<any>([]);
    const [storeName, setStoreName] = useState<any>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [total, setTotal] = useState<any>(0);

    useEffect(() => {
        // onGetUserList()
    }, [])
    useEffect(() => {
        if (!props.visible) {
            setTimeout(() => {
                reset()
            }, 200);
        } else {
            setPageIndex(1)
            if (props.type === 'gantt') {
                setSelectedRowKeys(store.ganttExecutorRowKeys)
                setSelectedRows(store.ganttExecutorRows)
                setStoreName(['SET_GANTTEXECUTORROWS', 'SET_GANTTEXECUTOROWKEYS'])
                onGetUserList()
            } else {
                setSelectedRowKeys(store.calendarExecutorRowKeys)
                setSelectedRows(store.calendarExecutorRows)
                //日历视图
                setStoreName(['SET_CALENDAREXECUTORROWS', 'SET_CALENDAREXECUTOROWKEYS'])
                onGetExecutorUserList({ index: 1, size: pageSize })

            }
        }
    }, [props.visible,props.type])
    // useEffect(() => {
    //     setSelectedRowKeys(store.ganttExecutorRowKeys)
    //     setSelectedRows(store.ganttExecutorRows)
    // }, [store.ganttExecutorRowKeys])
    // useEffect(() => {
    //     if (props.type === 'gantt') {
    //         //gantt图
    //         setStoreName(['SET_GANTTEXECUTORROWS', 'SET_GANTTEXECUTOROWKEYS'])
    //         onGetUserList()
    //     } else {
    //         //日历视图
    //         setStoreName(['SET_CALENDAREXECUTORROWS', 'SET_CALENDAREXECUTOROWKEYS'])
    //         onGetExecutorUserList({ index: 1, size: pageSize })
    //     }
    // }, [props.type])
    /**
   * @name 重置
   */
    const reset = () => {
        setSelectedRows([])
        setSelectedRowKeys([])

    }
    const onGetExecutorUserList = async (page: any) => {
        try {
            let res: any = await getUserList({ $skip: (page.index - 1) * page.size, $limit: page.size })
            if (res.ok) {
                setUserList(res.data.list)
                setTotal(res.data.total)
            }
        } catch { }
    }
    const onGetUserList = async () => {

        try {
            let res: any = await getUserList({ enabled: true })
            if (res.ok) {
                setUserList(res.data.list)
            }
        } catch { }
    }
    const columns: ColumnsType<DataType> = [
        {
            title: '用户列表',
            key: 'username',
            dataIndex: 'username',
            render: (record: any) => (

                <span>{record}
                </span>
            ),
        },
    ];
    const setModalVisible = (name: any, val: any) => {
        dispatch({
            type: name,
            data: val
        });
    }
    const memoTask = async () => {
        try {
            if (searchDate && searchDate.length > 1) {
                params.startDate = moment(searchDate[0]).format('YYYY-MM-DDT[00]:[00]:[00]')
                params.endDate = moment(searchDate[1]).format('YYYY-MM-DDT[23]:[59]:[59]')
            } else {
                params.startDate = moment(new Date()).format('YYYY-MM-DDT[00]:[00]:[00]')
                params.endDate = moment(new Date()).add(1, "months").format('YYYY-MM-DDT[23]:[59]:[59]')
            }
            if (selectedRowKeys && selectedRowKeys.length > 0) {
                params.executorIds = selectedRowKeys
                //selectedRows做交互用，不作为参数
                params.selectedRows = selectedRows
            }

            let res: any = await apis.memoLask(params)
            if (res.ok) {
                console.log(res.data)
                setTaskData(res.data)
                setTimeout(() => {
                    props.onClose && props.onClose()
                }, 200)
            }
        } catch (e) {
            console.log(e)
        }
    }
    const rowSelection = {
        selectedRowKeys,
        selectedRows,
        onChange: (selectedRowKeys1: React.Key[], selectedRows1: DataType[],) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows1);
            // console.log(`onSelectNone:${onSelectNone}`)
            // setSelectedRowKeys(selectedRowKeys.concat(selectedRowKeys1))
            // setSelectedRows(selectedRows.concat(selectedRows1))
        },
        onSelectAll:(selected:any, selectedRows:any, changeRows:any)=>{
            console.log(selected)
            console.log(selectedRows)
            console.log(changeRows)
            // let _selectedRows:any = deepCopy(selectedRows)
            // let _selectedRowKeys:any = deepCopy(selectedRowKeys)
        },
        onSelect:(record:any, selected:any,)=>{
            console.log(record, record.id)
            console.log(selected)
            console.log(selectedRowKeys,selectedRows)
            let _selectedRows:any = deepCopy(selectedRows)
            let _selectedRowKeys:any = deepCopy(selectedRowKeys)
            // _selectedRows=_selectedRows.concat(selectedRows)
            // _selectedRowKeys=_selectedRowKeys.concat(selectedRowKeys)

            if(selected){
                // let rows:any  = selectedRows.push(record)
                // let _selectedRowKeys:any = deepCopy(store.calendarExecutorRowKeys)
                // console.log( _selectedRowKeys,record.id)
                // let rowsKeys:any = _selectedRowKeys.concat([record.id])
                // console.log(rowsKeys)
               
                _selectedRows=_selectedRows.concat([record])
                
                _selectedRowKeys=_selectedRowKeys.concat([record.id])
                
            }else{
                _selectedRows= _selectedRows.filter((i:any)=>i.id!=record.id)
                _selectedRowKeys = _selectedRowKeys.filter((i:any)=>i!=record.id)
            }
            setSelectedRows(_selectedRows)
            setSelectedRowKeys(_selectedRowKeys)
        },

        getCheckboxProps: (record: DataType) => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
        hideSelectAll:true
    };

    return (
        <div style={{ height: '100vh', width: '100vw' }}>
            <Modal open={
                props.visible
            }
                okText={'确认'}
                cancelText={'取消'}
                onCancel={() => {
                    setModalVisible('setSelectedRows', false)
                    setSelectedRowKeys(params.executorIds)
                    setSelectedRows(params.selectedRows)
                    props.onClose && props.onClose()
                }}
                title='选择执行人'
                onOk={() => {
                    console.log(storeName)
                    // memoTask()
                    setModalVisible('setSelectedRows', false)
                    dispatch({
                        type: storeName[0],
                        data: selectedRows
                    });
                    dispatch({
                        type: storeName[1],
                        data: selectedRowKeys
                    });
                    props.onClose && props.onClose()

                }
                }
            >
                <Table
                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    rowKey='id'
                    pagination={false}
                    columns={columns}
                    dataSource={userList}
                    scroll={{ y: '45vh' }}
                />
                {props.type !== 'gantt' && <Paging current={pageIndex} total={total} onRefresh={(index: any, size: any) => {
                    setPageIndex(index)
                    setPageSize(size)
                    onGetExecutorUserList({ index: index, size: size })
                    // getList(inputVal, { index: index, size: size })

                }} />}
            </Modal>

        </div>
    )
}

export default ExecutorList
